
import AjaxService from '../Ajax/index.jsx';


var API = function() { };
API.prototype.actionName = 'cs:blockchains-list';
API.prototype.fetchPage = function() {
  return AjaxService.fetch(this.actionName)
    .then(function(response) {
      if (response) {
        return response;
      } else {
        return [];
      }
    });
};


export default API;

